// React
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import Company from "./Company";
// Constants
import { COMPANY_TABLE_HEADS } from "../../../configs/TableHeaderConstants";
import EntityConstants from "../../../configs/EntityConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Services
import { get } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Hooks
import usePermissions from "../../../hooks/usePermissions";

const Companies = () => {
    const permissions = usePermissions();
    const navigate = useNavigate();
    const spinService = SpinService();
    const [open, setOpen] = useState(false);
    const [id, setId] = useState(undefined);
    const [filter, setFilter] = useState({
        sort: "id",
        order: "desc",
        max: 10,
        offset: 0,
        search: ""
    });

    const [companies, setCompanies] = useState({
        entries: [],
        total_count: 0
    });

    const getCompanies = async () => {
        spinService.on();
        const response = await get(EntityConstants.COMPANIES, `sort=${filter.sort}&order=${filter.order}&max=${filter.max}&offset=${filter.offset + 1}&search=${filter.search}`);
        const data = await response.json();
        spinService.off();
        setCompanies(data);
    };

    const onClose = () => {
        getCompanies();
        setOpen(false);
    };


    useEffect(() => {
        if (permissions.has(PermissionConstants.COMPANY_VIEW)) {
            getCompanies();
        } else {
            navigate("/");
        };
    }, [filter]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        Companies
                    </Typography>
                    {/* <Button
                        variant="contained"
                        startIcon={<Iconify icon="eva:plus-fill" />}
                        onClick={() => { setId(undefined); setOpen(true) }}
                    >
                        New Company
                    </Button> */}
                </Stack>
                <Card>
                    <GoTable
                        tableHeads={COMPANY_TABLE_HEADS}
                        tableDatas={companies.entries}
                        totalCount={companies.total_count}
                        filter={filter}
                        onFilter={(filter) => setFilter(filter)}
                        onView={(row) => { setId(row.id); setOpen(true) }} />
                </Card>
            </Container>
            {
                permissions.has(PermissionConstants.COMPANY_VIEW) && open && <GoDrawer
                    title="Company"
                    open={open}
                    onClose={() => onClose()}
                >
                    <Company id={id} onClose={() => onClose()} />
                </GoDrawer>
            }

        </React.Fragment>
    );
}

export default Companies;